export default __webpack_public_path__ + "static/media/handyman-placeholder.dc0730f6.png";